module.exports = __webpack_public_path__ + "static/media/fvs_fremdlinge_24.0de16c02.jpg";